// Packages
import axios from "axios";
import sendExamConfirmationEmail from "./sendExamConfirmationEmail";

export const getScheduledTesters = (timeslot_id, updateValueHook=null) => {
    /* 
        params:
            timeslot_id: int;
                - timeSlot object id
            updateValueHook: hook function to update a value from parent component
    */
   const token = localStorage.getItem("access_token");
   axios
   .get(`${process.env.REACT_APP_API_BASE_URL}/api/scheduled-testers/${timeslot_id}/`,
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
   )
   .then((response) => {
        if (response.status === 200) {
            updateValueHook(response.data);
        }
   })
   .catch((error) => {
        if (error.response) {
            console.error("Response error:", error.response.data);
        } else {
            console.error("Error:", error.message);
        }
    });
}

export const putScheduledTesters = (timeslot_id, test_taker_id, component_type, pk) => {
    const token = localStorage.getItem("access_token");
    axios
    .put(
        `${process.env.REACT_APP_API_BASE_URL}/api/scheduled-testers/${pk}/`,
        {
            time_slot: timeslot_id,
            test_taker: test_taker_id,
            component_type: component_type,
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        }
    )
    .then((response) => {
        if (response.status === 200) {
            sendExamConfirmationEmail(timeslot_id);
        }
    })
    .catch((error) => {
        if (error.response) {
            console.error("Response error:", error.response.data);
        } else {
            console.error("Error:", error.message);
        }
    });

}

export const postScheduledTesters = (timeslot_id, test_taker_id, component_type, hook=null) => {
    const token = localStorage.getItem("access_token");
    axios
    .post(
        `${process.env.REACT_APP_API_BASE_URL}/api/scheduled-testers/`,
        {
            time_slot: timeslot_id,
            test_taker: test_taker_id,
            component_type: component_type,
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        }
    )
    .then((response) => {
        if (hook) {
            hook(response);
        };
        if (response.status === 201) {
            sendExamConfirmationEmail(timeslot_id, test_taker_id);
        }
    })
    .catch((error) => {
        if (error.response) {
            hook(error.response);
        } else {
            console.error("Error:", error.message);
        }
    });

}

export const deleteScheduledTesters = (pk, hook=null) => {
    const token = localStorage.getItem("access_token");
    axios
    .delete(
        `${process.env.REACT_APP_API_BASE_URL}/api/scheduled-testers/${pk}/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        }
    )
    .then((response) => {
        if (hook) {
            hook(response.status);
        };
    })
    .catch((error) => {
        if (error.response) {
            hook(error.response.status);
        } else {
            console.error("Error:", error.message);
        }
    });
}